import React from 'react';
import { useNavigate } from 'react-router-dom';
import BaseLayout from '../components/BaseLayout';
import TermsOfService from '../components/TermsOfService';
import './TermsOfServicePage.css';

const TermsOfServicePage: React.FC = () => {
  const navigate = useNavigate();

  const handleBack = () => {
    navigate(-1); // Go back to previous page
  };

  return (
    <BaseLayout className="terms-page">
      <div className="terms-page-header">
        <button className="terms-back-btn" onClick={handleBack}>
          ← Quay lại
        </button>
        <h1>Điều khoản sử dụng</h1>
      </div>
      
      <div className="terms-page-content">
        <TermsOfService />
      </div>
    </BaseLayout>
  );
};

export default TermsOfServicePage;